import React from 'react';
import classNames from 'classnames';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import Raw from 'ui/Raw/Raw';
import Navbar from 'ui/Navbar/Navbar';
import {useWaypoints} from 'ui/Navbar/useWaypoints';
import Banner from 'ui/Banner/Banner';
import Social from 'ui/Social/Social';

import getTeamLink from '../../../../common/views/helpers/getTeamLink';
import message from '../../../../common/views/helpers/message';
import getJobUri from '../../../../common/views/helpers/getJobUri';
import './JobPage.less';

const ApplyButton = (props) => (
    <a
        href={`${props.href}/apply?source=HomeAwayC`}
        className={classNames('btn btn-primary', props.classes)}
    >
        {props.label}
    </a>
);

const JobPage = ({isMobile, data: {fullLocale, content, translations}}) => {
    const msgopts = {data: {root: {fullLocale, translations}}, hash: {}}; // TODO: figure out what to do here
    const {links, visible, buttonWaypoint} = useWaypoints({
        withBack: {href: '/careers/openings', label: 'Back'},
        withButton: true,
    });
    const section = content && content.sections[0];

    if (!section) {
        return null;
    }

    const applyButtonProps = {
        href: section.requisition.External_URL,
        label: translations['careers.requisition.apply'],
    };

    return (
        <div className="container-requisition">
            <Navbar
                links={links}
                active={1}
                button={
                    <ApplyButton
                        {...applyButtonProps}
                        classes={classNames('btn-sm', {
                            'btn-visible': isMobile || visible,
                        })}
                    />
                }
            />
            <Banner image="//csvcus.homeaway.com/rsrcs/stab-cms-resources/0.4.10/images/careers/career-jobposting.jpg">
                <div className="container">
                    <Raw
                        component={(props) => (
                            <p className="text-white" {...props} />
                        )}
                        content={content.sections[0].requisition.jobFamily}
                    />

                    <Raw
                        component={(props) => (
                            <h1 className="text-white" {...props} />
                        )}
                        content={content.sections[0].requisition.Job_Title}
                    />

                    <Raw
                        component={(props) => (
                            <h3 className="text-white" {...props} />
                        )}
                        content={content.sections[0].requisition.Location_City}
                    />
                </div>
            </Banner>

            <div className="container container--overlap requisition-body">
                <div className="row">
                    <main className="col-md-7">
                        <Raw
                            content={
                                content.sections[0].requisition.Job_Description
                            }
                        />
                    </main>
                    <aside className="col-md-offset-1 col-md-4">
                        {buttonWaypoint}
                        <ApplyButton
                            {...applyButtonProps}
                            classes="hidden-xs"
                        />

                        <h4>{translations['careers.requisition.resources']}</h4>

                        <section>
                            <p>{section.team.description}</p>
                            <Raw
                                content={getTeamLink(content.sections[0].team, {
                                    ...msgopts,
                                    hash: {
                                        CATEGORY: section.team.title,
                                    },
                                })}
                            />
                        </section>

                        <section>
                            <h5>
                                {
                                    translations[
                                        'careers.requisition.working.at.homeaway.title'
                                    ]
                                }
                            </h5>
                            <p>
                                {
                                    translations[
                                        'careers.requisition.working.at.homeaway.body'
                                    ]
                                }
                            </p>
                        </section>

                        <section>
                            <Raw
                                content={message(
                                    'careers.requisition.other.jobs.in',
                                    {
                                        ...msgopts,
                                        hash: {
                                            CATEGORY: section.team.title,
                                        },
                                    },
                                )}
                                component={(props) => <h5 {...props} />}
                            />

                            {Array.prototype.concat
                                .apply(
                                    [],
                                    section.locationCities.map(
                                        (city) => city.locations,
                                    ),
                                )
                                .map((location) => {
                                    return (
                                        <ul
                                            className="list-unstyled"
                                            key={location.locationId}
                                        >
                                            <li className="text-muted">
                                                {location.location}
                                            </li>
                                            {location.requisitionSummaries.map(
                                                (summary) => {
                                                    return (
                                                        <li
                                                            key={
                                                                summary.Job_Requisition
                                                            }
                                                        >
                                                            <Raw
                                                                component={(
                                                                    props,
                                                                ) => (
                                                                    <a
                                                                        href={`/careers/job/${getJobUri(
                                                                            summary.Job_Requisition,
                                                                            summary.Job_Title,
                                                                        )}/`}
                                                                        {...props}
                                                                    />
                                                                )}
                                                                content={
                                                                    summary.Job_Title
                                                                }
                                                            />
                                                        </li>
                                                    );
                                                },
                                            )}
                                        </ul>
                                    );
                                })}
                        </section>
                    </aside>
                </div>
            </div>
            <Social
                {...content.sections.filter(
                    (sect) => sect.type === 'careersSocial',
                )[0]}
            />
        </div>
    );
};

export default determineIfMobile(JobPage);
